/***
 * 示例
 *
 */
import $axios from "@/service/httpServer";
import { baseUrl } from "./oldNew";

export const getDemoData = (p) => $axios.get("/demo", p); // 获取数据

//获取城市公司

export const getDataPermission = (p) =>
  $axios.get(baseUrl + "/marketing/recommend/App/getDataPermission", p);

//获取项目
export const getProjectList = (p) =>
  $axios.get(baseUrl + "/marketing/recommend/getProjectList", p);
// 移动端查看推荐个数统计
export const getNumByProjectCode = (p) =>
  $axios.get(baseUrl + "/marketing/recommend/App/getNumByProjectCode", p);

//移动端查看推荐详情
export const getDetailsById = (p) =>
  $axios.get(baseUrl + "/marketing/recommend/App/getDetailsById", p);
// 移动端查看推荐列表

// export const getListByProjectCode = (p) =>
//   $axios.get(baseUrl + "/marketing/recommend/App/getListByProjectCode", p);
export const getListByProjectCode = (p) =>
  $axios.get(baseUrl + "/marketing/recommend/App/recommendList", p);
//置业顾问查询

export const advi = (p) =>
  $axios.get(baseUrl + `/marketing/recommend/App/ownership/adviser`, p);
//OssConfig
export const OssConfiggetOssConfig = (p) =>
  $axios.get("/dwwb-portal/ossToken/stsToken?system=nhfcloms-h5", p);
//已分配已处理
// export const processed = (p) =>
//   $axios.get("/marketing/recommend/App/allocated/processed", p);
export const processed = (p) =>
  $axios.get(baseUrl + "/marketing/recommend/App/recommendList", p);
//已分配未处理

// export const untreated = (p) =>
//   $axios.get("/marketing/recommend/App/allocated/untreated", p);

export const untreated = (p) =>
  $axios.get(baseUrl + "/marketing/recommend/App/recommendList", p);
//销售经理提醒
export const remind = (p) =>
  $axios.get(baseUrl + "/marketing/adviser/pushMessage", p);
//发送短信
export const sendInfo = (p) =>
  $axios.get(baseUrl + "/marketing/adviser/sms/send", p);
//大数据 - 老带新城市指标
export const indexByOrg = (p) =>
  $axios.post("http://api2.newhope.cn/openapi/open/customer/ldx/indexByOrg", p);
//大数据 - 老带新项目指标
export const indexByProj = (p) =>
  $axios.post(
    "http://api2.newhope.cn/openapi/open/customer/ldx/indexByProj",
    p
  );
//移动端分配推荐
export const distribute = (p) =>
  // $axios.post(`/customer/recommend/App/distribute?id=${p}`);
  $axios.post(baseUrl + "/marketing/recommend/App/distribution", p);
//合资待审核推荐列表

// export const approval = (p) =>
//   $axios.get(baseUrl + "/marketing/recommend/App/venture/approval", p);
export const approval = (p) =>
  $axios.get(baseUrl + "/marketing/recommend/App/recommendList", p);
//合资待审核详情
export const venture = (p) =>
  $axios.get(baseUrl + "/marketing/auth/getAuthDetailsByOther", p);
//认证总数(城市);
export const cityTotal = (p) =>
  $axios.get("/recommend/App/authentication/cityTotal", p);
//认证总数(项目);
export const projectTotal = (p) =>
  $axios.get("/recommend/App/authentication/projectTotal", p);
//申诉审核
export const appealAudit = (p) =>
  $axios.post(baseUrl + "/marketing/auth/appealAudit", p);

//销售经理-确认带访
export const confirm = (p) =>
  $axios.post(baseUrl + "/marketing/recommend/miniProgram/confirm", p);

//查询-销售经理-老业主带访
// export const managerList = (p) =>
//   $axios.get(baseUrl + "/marketing/recommend/miniProgram/manager/list", p);
export const managerList = (p) =>
  $axios.get(baseUrl + "/marketing/recommend/App/recommendList", p);
//     小程序认证 判断
export const userlist = (p) => $axios.get("/customer/userroom/userlist", p);
//     小程序认证 判断
export const getUserIdentity = (p) =>
  $axios.get("/customer/auth/getUserIdentity", p);
